export default "__VITE_ASSET__DA3eZ7jK__"